import { createFileRoute } from '@tanstack/react-router';
import { DataIndexCatchAllRedirect } from '@/pages/workspaces/data-index/routing';
import { LastWorkspaceResolver } from './-route-layouts';

function JourneysDataIndexSplatRoute() {
  return (
    <LastWorkspaceResolver>
      <DataIndexCatchAllRedirect />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/data-index/$')({
  component: JourneysDataIndexSplatRoute,
});
